module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', [_c('div', {
    staticClass: "timeline__hoverable"
  }, [_c('header', {
    staticClass: "timeline__header",
    on: {
      "click": _vm.goToPeriod
    }
  }, [_c('h3', {
    staticClass: "timeline__title"
  }, [_vm._v(_vm._s(_vm.period.title))]), _c('span', {
    staticClass: "timeline__meta"
  }, [_c('span', {
    staticClass: "timeline__date"
  }, [_vm._v(_vm._s(_vm.periodDates))])])])]), _c('ul', {
    staticClass: "timeline__content timeline__content--list"
  }, _vm._l((_vm.assignments), function(assignment) {
    return _c('li', {
      staticClass: "timeline__subitem",
      class: {
        'is-active': _vm.isActiveAssignment(assignment), 'is-disabled': _vm.isDisabledAssignment(assignment)
      },
      on: {
        "click": function($event) {
          _vm.goToAssignment($event, assignment)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(assignment.title))])])
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1722ee76","preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/sidebar/Period.vue
// module id = zO49
// module chunks = 1